/* globals _ */
import moment from "moment";

(function (angular) {
  "use strict";

  angular
    .module("fleetviewApp")
    .component("complianceGroupRoutes", {
      template: require("./compliance-routes.component.html"),
      controller: ComplianceRoutesController
    });

  ComplianceRoutesController.$inject = [
    "$scope",
    "$location",
    "LayoutService",
    "complianceMapService",
    "complianceService",
    "$stateParams",
    "$state",
    "RoutingProfiles",
    "mapUtilities",
    "$q",
    "UserProvider",
    "ComplianceRoutingProfileService",
    "cacheService"
  ];

  function ComplianceRoutesController($scope, $location, LayoutService, complianceMapService, complianceService, $stateParams, $state, RoutingProfiles, mapUtilities, $q, UserProvider, ComplianceRoutingProfileService, cacheService) {
    let vm = this;
    vm.settings = $stateParams.settings;
    if (!vm.settings || _.isEmpty(vm.settings)) {
      vm.settings = cacheService.getSearchSettings();
    }
    vm.currentState = $stateParams.currentState;
    vm.$onInit = init;
    vm.$onDestroy = destroy;
    vm.leftPanelWidth = leftPanelWidth;
    vm.selectRoute = selectRoute;
    vm.frameRoute = frameRoute;
    vm.frameAll = frameAll;
    vm.routedetails = routedetails;
    vm.setRouteVisibility = setRouteVisibility;
    vm.setRoutePingsVisibility = setRoutePingsVisibility;
    vm.toggleAllRoutes = toggleAllRoutes;
    vm.nextCompliancePage = nextCompliancePage;
    vm.previousCompliancePage = previousCompliancePage;
    vm.changeProfile = complianceService.changeProfile;
    vm.noRoutingProfiles = complianceService.noRoutingProfiles;
    vm.zoomtoStop = zoomtoStop;
    vm.groupId = $stateParams.groupId;

    function init() {
      complianceMapService.initMap();
      vm.selectedRouteId = 0;

      //pagination properties
      vm.firstItemNum = 1;
      vm.lastItemNum = 10;
      vm.routesPerPage = 10;
      vm.currentPageNum = $stateParams.pageNumber;
      //vm.oorCost = 1;
      vm.totalPagesNum = 1;

      // stores the routes in the current page, which helps to synchronize with the view
      vm.routeList = [];

      vm.isLoading = false;

      $scope.$watch(() => vm.settings, () => {

        vm.isLoading = true;

        cacheService.clearCachedRouteResponses();  //If the user changes search settings in route search, should also clear cache

        let pageNumber = vm.currentPageNum > 1 ? vm.currentPageNum : $location.search().pageNumber;

        if (_isNumber(pageNumber)) {
          pageNumber = parseInt(pageNumber);

          vm.currentPageNum = pageNumber;
        } else {
          vm.currentPageNum = 1;
        }

        // draw all routes first, and then hide the ones that we want to hide.
        complianceService.initRoutes(vm, vm.settings, vm.currentPageNum).then(function () {
          if (vm.routeList.length === 0) {
            return;
          }

          // keep a route object to sync between the view and the model
          vm.route = vm.routeList[vm.currentPageIndex];

          let routeVisibilityList = complianceService.getRouteVisibilityList();

          let start = (vm.currentPageNum - 1) * vm.routesPerPage;
          let end;
          if ((vm.currentPageNum * vm.routesPerPage) < routeVisibilityList.length) {
            end = vm.currentPageNum * vm.routesPerPage;
          } else {
            end = routeVisibilityList.length;
          }

          for (let i = start; i < end; i++) {
            vm.setRouteVisibility(routeVisibilityList[i].tripId, routeVisibilityList[i].isVisible);
          }
        });

      });

      $scope.$on("mapRouteClicked", (state, msg) => {
        // console.log(msg.tripId);
        vm.selectRoute(msg.tripId, true);
        // console.log(vm.routeList);
        let routeToUse = [];
        vm.routeList.forEach(route => {
          if (route.tripId === msg.tripId) {
            routeToUse = route;
          }
        });
        vm.routedetails(routeToUse);
      });
    }

    function destroy() {
      complianceMapService.clearMap();
    }

    // when a user selects a route, we want the route to be visible
    // and the visibility should persist until they unselect the route
    function selectRoute(tripId, isVisible) {
      vm.selectedRouteId = tripId;
      vm.setRouteVisibility(tripId, isVisible);
    }

    function setRouteVisibility(tripId, isVisible) {
      // set the route in the view to visible
      let idx = vm.routeList.map(r => r.tripId).indexOf(tripId);
      vm.routeList[idx].isVisible = isVisible;

      // update our route visibility array in complianceService
      let index = complianceService.getRouteVisibilityList().map(r => r.tripId).indexOf(tripId);
      complianceService.setRouteVisibility(index, isVisible);

      // set the route to be visible in the map
      complianceMapService.setRouteVisibility(tripId, isVisible);

    }

    function setRoutePingsVisibility(tripId, routePingsVisible) {
      // set the route pings visibility in the view
      let idx = vm.routeList.map(r => r.tripId).indexOf(tripId);
      vm.routeList[idx].isRoutePingsVisible = routePingsVisible;

      complianceMapService.setRoutePingsVisibility(tripId, routePingsVisible);
    }

    function toggleAllRoutes(routeList, areVisible) {
      _.forEach(routeList, (route) => {
        setRouteVisibility(route.tripId, areVisible);
        route.isVisible = areVisible;
      });
    }

    function frameAll() {
      complianceMapService.frameAllRoutes();
    }

    function frameRoute(tripId) {
      complianceMapService.frameRoute(tripId);
    }

    function zoomtoStop(latlong) {
      complianceMapService.zoomtoStop(latlong);
    }
    function previousCompliancePage() {
      vm.currentPageNum--;
      vm.routeList = [];

      // based on our route visibility info, keep or hide the route
      complianceService.getRoutePage(vm, vm.settings, vm.currentPageNum)
        .then(function () {
          vm.route = vm.routeList[vm.currentPageIndex];
          let routeVisibilityList = complianceService.getRouteVisibilityList();

          let start = (vm.currentPageNum - 1) * vm.routesPerPage;
          let end = start + vm.routesPerPage;

          for (let i = start; i < end; i++) {
            vm.setRouteVisibility(routeVisibilityList[i].tripId, routeVisibilityList[i].isVisible);
          }
        });
    }

    function nextCompliancePage() {
      vm.currentPageNum++;
      vm.routeList = [];

      // based on our route visibility info, keep or hide the route
      complianceService.getRoutePage(vm, vm.settings, vm.currentPageNum)
        .then(function () {
          vm.route = vm.routeList[vm.currentPageIndex];
          let routeVisibilityList = complianceService.getRouteVisibilityList();

          let start = (vm.currentPageNum - 1) * vm.routesPerPage;
          let end;
          if ((vm.currentPageNum * vm.routesPerPage) < routeVisibilityList.length) {
            end = vm.currentPageNum * vm.routesPerPage;
          } else {
            end = routeVisibilityList.length;
          }

          for (let i = start; i < end; i++) {
            vm.setRouteVisibility(routeVisibilityList[i].tripId, routeVisibilityList[i].isVisible);
          }
        });
    }

    function leftPanelWidth() {
      return LayoutService.getLeftPanelWidth(vm);
    }

    // todo: put into common file
    function _isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function routedetails(route) {
      $state.go($stateParams.childState, {
        pageNumber: vm.currentPageNum,
        pageIndex: vm.routeList.indexOf(route),
        totalPagesNum: vm.totalPagesNum,
        queryUrl: $stateParams.queryUrl
      });
    }

  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/compliance/compliance-routes.component.js